import {
  Classes,
  FormGroup,
  Icon,
  Text,
  Colors,
  Checkbox,
  ControlGroup,
} from '@blueprintjs/core'
import LabelWithTooltip from './LabelWithTooltip'

const allAlgorithms = ['NMF', 'kmeans', 'kmodes', 'LC', 'SNMF']

const algorithmDescriptions = {
  NMF: 'Non-negative Matrix Factorization: Discovers latent patterns by decomposing the data into weighted combinations of features. Good for continuous data and finding natural groupings.',
  kmeans: 'K-Means Clustering: Groups respondents by minimizing distance to cluster centers. Fast and effective for continuous numerical data with spherical clusters.',
  kmodes: 'K-Modes Clustering: Specialized for categorical data, groups by mode-based similarity. Ideal for surveys with primarily categorical responses.',
  LC: 'Latent Class Analysis: Statistical model that identifies hidden subgroups based on response patterns. Handles mixed data types and provides probabilistic assignments.',
  SNMF: 'Sinkhorn-NMF: Balanced NMF variant using optimal transport. Produces more evenly-sized segments while maintaining cluster quality. Supports hard/soft assignment modes.',
}

export default function AlgorithmSelector({ algorithmsSelected, setAlgorithmsSelected }) {
  const handleToggle = (algorithm) => {
    setAlgorithmsSelected(prev =>
      prev.includes(algorithm)
        ? prev.filter(a => a !== algorithm)
        : [...prev, algorithm]
    )
  }

  return (
    <FormGroup
      label={
        <span style={{ fontSize: 13 }}>
          <Icon
            size={14}
            icon="function"
            style={{ marginRight: 3 }}
            className={Classes.TEXT_MUTED}
          />
          Algorithms
        </span>
      }
      helperText={
        algorithmsSelected.length === 0 ? (
          <Text style={{ color: Colors.RED3, fontWeight: 500 }}>
            Select at least 1 algorithm
          </Text>
        ) : null
      }
    >
      <ControlGroup fill>
        {allAlgorithms.map(algorithm => (
          <Checkbox
            key={algorithm}
            label={
              <LabelWithTooltip
                label={algorithm}
                tooltip={algorithmDescriptions[algorithm]}
              />
            }
            checked={algorithmsSelected.includes(algorithm)}
            onChange={() => handleToggle(algorithm)}
          />
        ))}
      </ControlGroup>
    </FormGroup>
  )
}

export { allAlgorithms }
